.chartCards{background-color:#fafad2}
/*# sourceMappingURL=graph-dialog.component-UQPWBF7I.css.map */
